import type {
  HazardIdentification,
  MachineLocation,
} from '@/shared/hooks/api/machineryDirectiveCompliance'
import { getMachineLocationDisplayName } from '../machine-locations/buildMachineLocationRows'

export function getHazardMachineLocationLabel(
  hazard: HazardIdentification,
  machineLocationsById: ReadonlyMap<string, MachineLocation>,
  translate: (key: string) => string
): string | null {
  const machineLocationId = hazard.machineLocationId
  if (machineLocationId == null || machineLocationId === '') {
    return null
  }

  const location = machineLocationsById.get(machineLocationId)
  if (location == null) {
    return null
  }

  return getMachineLocationDisplayName(location, translate)
}

export function hazardHasNoMachineLocation(
  hazard: HazardIdentification
): boolean {
  const machineLocationId = hazard.machineLocationId
  return machineLocationId == null || machineLocationId === ''
}
